import React from "react";
import { Link, useParams } from "react-router-dom";
import { Card, Image, Title, Description, Button, Circle } from "./ProductsSlider.style";

const formatCategory = (category) => {
  return category.toLowerCase().replace(/\s+/g, '-');
};

const ProductCard = ({ product, isSingleItem }) => {

  const handleClick = (e) => {
    const contentProduct = document.getElementById('content-product');
    if (contentProduct) {
      contentProduct.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <Card isSingleItem={isSingleItem}>
      <Image>
        <Circle brand={product.lineId} category={formatCategory(product.category)} />
        <img src={product.imageUrl} alt={product.name} />
      </Image>
      <Title>{product.name}</Title>
      <Description>{product.shortDescription}</Description>
      <Button 
        as={Link} 
        to={`/lineas/${product.lineId}/${formatCategory(product.category)}/${product.id}`}
        onClick={handleClick}
      >
        Ver Más
      </Button>
    </Card>
  );
};

export default ProductCard;
